/**
 * @generated SignedSource<<763c1678f0acc56081f93856868da816>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowsePhotoPreviewModal_photos$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly url: string | null;
    } | null;
  } | null> | null;
  readonly totalResults: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowsePhotoContainerMobile_photos" | "PhotosSearchBrowsePhotoContainer_photos">;
  readonly " $fragmentType": "PhotosSearchBrowsePhotoPreviewModal_photos";
};
export type PhotosSearchBrowsePhotoPreviewModal_photos$key = {
  readonly " $data"?: PhotosSearchBrowsePhotoPreviewModal_photos$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowsePhotoPreviewModal_photos">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotosSearchBrowsePhotoPreviewModal_photos",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PhotosSearchBrowsePhotoContainer_photos"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PhotosSearchBrowsePhotoContainerMobile_photos"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalResults",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotosSearchBrowseQueryEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PhotosSearchBrowsePhoto",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowseQueryConnection",
  "abstractKey": null
};

(node as any).hash = "a4386522a66eae0f41410135ca18cadb";

export default node;
